PROMPT_STATUSES =
  WAITING: 0
  REJECTED: 1
  EDITED: 2
  SENT: 3

module.exports = PROMPT_STATUSES